// ----
// JS for handling section editors table on NBNJ BookBasicInfo.
// ----
var Theme = Theme || {};

Theme.BookSectionEditors = (function ($) {
    return {
        init: _init
    };

    function _init() {
        if (!_myComponentIsOnPage()) {
            return;
        }
        sectionEditorsToggle();
    }

    function _myComponentIsOnPage() {
        return $('.book-info__section-editors').length;
    }

    function sectionEditorsToggle() {
        $('#js-section-editors-dropdown').click(function () {
            $('#js-section-editors-dropdown-content').toggle(600, function () {
                var $icon = $('#section-editors-arrow')
                if ($('#js-section-editors-dropdown-content').is(':visible')) {
                    $icon.removeClass('icon-general-arrow-filled-down').addClass('icon-general-arrow-filled-up');
                } else {
                    $icon.removeClass('icon-general-arrow-filled-up').addClass('icon-general-arrow-filled-down');
                }
            });
        });  
    }

})(jQuery);